/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Review_Comment_LabelInputs */

const en_ticket_review_comment_label = /** @type {(inputs: Ticket_Review_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please leave your feedback below`)
};

const ja_ticket_review_comment_label = /** @type {(inputs: Ticket_Review_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ご意見をお聞かせください`)
};

const fr_ticket_review_comment_label = /** @type {(inputs: Ticket_Review_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez laisser votre avis ci-dessous`)
};

const de_ticket_review_comment_label = /** @type {(inputs: Ticket_Review_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte hinterlassen Sie Ihr Feedback unten`)
};

/**
* | output |
* | --- |
* | "Please leave your feedback below" |
*
* @param {Ticket_Review_Comment_LabelInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_review_comment_label = /** @type {((inputs?: Ticket_Review_Comment_LabelInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Review_Comment_LabelInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_review_comment_label(inputs)
	if (locale === "ja") return ja_ticket_review_comment_label(inputs)
	if (locale === "fr") return fr_ticket_review_comment_label(inputs)
	return de_ticket_review_comment_label(inputs)
});